// src/components/Dashboard.js
import React, { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase"; // Firestore instance
import { useNavigate } from "react-router-dom";

function Dashboard() {
  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({ address: "", contact: "" });
  const navigate = useNavigate();

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        const userRef = doc(db, "users", currentUser.uid);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          const data = userSnap.data();
          setUserData(data);
          setFormData({
            area: data.area || "",
            district: data.district || "",
            contact: data.contact || "",
          });
        }
      }
    });

    return () => unsubscribe();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    try {
      const userRef = doc(db, "users", user.uid);
      await updateDoc(userRef, {
        // address: formData.address,
        // contact: formData.contact,
        area: formData.area,
        district: formData.district,
        contact: formData.contact,
      });
      setUserData((prev) => ({
        ...prev,
        // address: formData.address,
        // contact: formData.contact,
        area: formData.area,
        district: formData.district,
        contact: formData.contact,
      }));
      setEditMode(false);
      alert("Details updated successfully.");
    } catch (error) {
      console.error("Error updating user:", error);
      alert("Failed to update details.");
    }
  };

  return (
    <div className="card p-4 mt-4">
      <h3>Welcome to {userData.name}</h3>

      {user && (
        <div className="mt-3">
          <div className="d-flex flex-row gap-5 ">
            <p>
              <strong>AC ID:</strong> {userData.accountId}
            </p>
            <p>
              <strong>User Role</strong> {userData.role}
            </p>
            <p>
              <strong>Email:</strong> {user.email}
            </p>
          </div>

          {editMode ? (
            <>
              <div className="mb-2">
                <label>Area</label>
                <input
                  type="text"
                  name="area"
                  className="form-control"
                  value={formData.area}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-2">
                <label>District</label>
                <input
                  type="text"
                  name="district"
                  className="form-control"
                  value={formData.district}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-2">
                <label>Contact:</label>
                <input
                  type="text"
                  name="contact"
                  className="form-control"
                  value={formData.contact}
                  onChange={handleChange}
                />
              </div>
              <button className="btn btn-success me-2" onClick={handleSave}>
                Save
              </button>
              <button
                className="btn btn-secondary"
                onClick={() => setEditMode(false)}
              >
                Cancel
              </button>
            </>
          ) : (
            <>
              <p>
                <strong>Address:</strong> {userData.area},{userData.district}
              </p>
              <p>
                <strong>Contact:</strong> {userData.contact || "Not set"}
              </p>
              <button
                className="btn btn-outline-primary"
                onClick={() => setEditMode(true)}
              >
                Edit Details
              </button>
            </>
          )}

          <hr />
          <button
            className="btn btn-primary mt-3"
            onClick={() => navigate("/seva-dashboard")}
          >
            Book Seva Ticket
          </button>
        </div>
      )}
    </div>
  );
}

export default Dashboard;
